/**
 * Conditionally loads modal.js only if .content-modal exists in the DOM
 */
export function initModalLoader() {
    // Check if content-modal exists
    if (document.querySelector('.content-modal')) {
        // Dynamically import modal.js only when needed
        import('/static/js/templates/modal.js')
            .then(() => {
                console.log('Modal module loaded successfully');
            })
            .catch((error) => {
                console.error('Failed to load modal module:', error);
            });
    }
}

